import React from "react";

export const MonitorIcon = (): JSX.Element => {
    return (
        <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M22.75 0.75H2.75C1.64543 0.75 0.75 1.64543 0.75 2.75V12.75C0.75 13.8546 1.64543 14.75 2.75 14.75H22.75C23.8546 14.75 24.75 13.8546 24.75 12.75V2.75C24.75 1.64543 23.8546 0.75 22.75 0.75Z"
                stroke="var(--app-chart-chartEleventhSet)"
                strokeWidth="1.5"
            />
            <path d="M12.75 14.75V17.75" stroke="#D3AD35" strokeWidth="1.5" />
            <path d="M7.75 17.75H17.75" stroke="#D3AD35" strokeWidth="1.5" strokeLinecap="round" />
            <path
                opacity="0.15"
                d="M21.75 2.75H14.75C14.1977 2.75 13.75 3.19772 13.75 3.75V8.75C13.75 9.30228 14.1977 9.75 14.75 9.75H21.75C22.3023 9.75 22.75 9.30228 22.75 8.75V3.75C22.75 3.19772 22.3023 2.75 21.75 2.75Z"
                fill="#A49049"
            />
        </svg>
    );
};
